import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { BaseColumnComponent } from '../../../../record/services/base-column-component';
import { DownloadRow, FoutenCellData } from '../../../entities/download-row.entity';

@Component({
    standalone: false,
    selector: 'digihaven-download-fouten-cell',
    templateUrl: './download-fouten-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadFoutenCellComponent extends BaseColumnComponent<DownloadRow> {
    readonly fouten$: Observable<FoutenCellData>;

    constructor(cd: ChangeDetectorRef) {
        super(cd);

        this.fouten$ = this.data$.pipe(switchMap(row => row.fouten$));
    }
}
